import { render } from "./register.vue?vue&type=template&id=3f95ae3c&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=3f95ae3c&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/funfindhk20250610/front-vue-src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f95ae3c"]])

export default __exports__